import Vue from 'vue'
import * as list from './list'

Object.keys(list).forEach(key => {
  Vue.filter(key, list[key])
})